/** Default Metronic blank avatar served from the frontend `public/` folder. */
export const DEFAULT_AVATAR = 'media/avatars/blank.png';

/**
 * Build a usable `<img src>` for a user avatar.
 *
 * - Absolute / data / blob URLs are returned as-is
 * - `media/...` paths are frontend public assets
 * - Everything else (e.g. `uploads/avatars/...`) is served from the API origin
 */
export function resolveAvatarUrl(
  path?: string | null,
  absoluteUrl?: string | null
): string {
  const preferred = (absoluteUrl || '').trim();
  if (isDirectUrl(preferred)) {
    return preferred;
  }

  const value = (path || preferred || '').trim();
  if (!value) {
    return DEFAULT_AVATAR;
  }

  if (isDirectUrl(value)) {
    return value;
  }

  const normalized = value.replace(/^\//, '');

  // Frontend-bundled Metronic / public assets
  if (normalized.startsWith('media/')) {
    return normalized;
  }

  const apiBase = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '');
  return apiBase ? `${apiBase}/${normalized}` : normalized;
}

function isDirectUrl(value: string): boolean {
  return (
    /^https?:\/\//i.test(value) ||
    value.startsWith('data:') ||
    value.startsWith('blob:')
  );
}
